import {ActionTypes} from '../actions';
import {ActionTypes as OrderActionTypes} from '../../order/actions';
import createReducer, {getActionsObject} from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'list': [],
  'filteredList': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const FORM_INITIAL_STATE = {
  'loadingOrders': false,
  'ordersList': {},
  'selectedOrder': null,
  'selectedTransportType': 'maritime',
  'showOrderDetail': true,
};

const filterList = (list, value) => {
  return [...list].filter((element) =>
    [
      element.code || '',
      element.origin || '',
      element.name || '',
    ].some((text) =>
      text.toLowerCase().includes(value.toLowerCase()) || value === ''
    )
  );
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const provider = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_PROVIDERS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.LOAD_PROVIDERS_SUCCESS]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'filteredList': action.response.data,
      'loading': false,
      'page': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.LOAD_PROVIDERS_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'page': [],
      'loading': false,
    }),
    [ActionTypes.CHANGE_PROVIDER_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterText': action.payload,
    }),
    [ActionTypes.FILTER_PROVIDERS]: (state, action) => ({
      ...state,
      'filteredList': [...filterList(state.list, action.payload)],
      'pageNumber': 0,
      'page': [...getPage([...filterList(state.list, action.payload)], 0, state.pageSize)],
    }),
    [ActionTypes.CHANGE_PROVIDERS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'page': [...getPage(state.filteredList, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_PROVIDERS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'page': [...getPage(state.filteredList, 0, action.payload)],
    }),
  })(state, action);
};

export const providerForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.INITIALIZE_PROVIDER_DATA]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'origin': action.payload.origin || 'JPN-392',
        'manualOrderCycle': action.payload.manualOrderCycle || 0,
        'defaultLeadTimeValues': action.payload.defaultLeadTimeValues || 'MARITIMO',
        'manualAerialLeadTime': action.payload.manualAerialLeadTime || 0,
        'manualAerialMax': action.payload.manualAerialMax || 0,
        'manualAerialMin': action.payload.manualAerialMin || 0,
        'manualMaritimeLeadTime': action.payload.manualMaritimeLeadTime || 0,
        'manualMaritimeMax': action.payload.manualMaritimeMax || 0,
        'manualMaritimeMin': action.payload.manualMaritimeMin || 0,
        'manualInenAerialLeadTime': action.payload.manualInenAerialLeadTime || 0,
        'manualInenAerialMax': action.payload.manualInenAerialMax || 0,
        'manualInenAerialMin': action.payload.manualInenAerialMin || 0,
        'manualInenMaritimeLeadTime': action.payload.manualInenMaritimeLeadTime || 0,
        'manualInenMaritimeMax': action.payload.manualInenMaritimeMax || 0,
        'manualInenMaritimeMin': action.payload.manualInenMaritimeMin || 0,
        'manualMaritimeSafetyStockLeadTime': action.payload.manualMaritimeSafetyStockLeadTime || 0,
        'manualInenMaritimeSafetyStockLeadTime':
          action.payload.manualInenMaritimeSafetyStockLeadTime || 0,
      },
    }),
    [ActionTypes.LOAD_PROVIDER_ORDERS_REQUEST]: (state, action) => ({
      ...state,
      'loadingOrders': true,
    }),
    [ActionTypes.LOAD_PROVIDER_ORDERS_SUCCESS]: (state, action) => ({
      ...state,
      'ordersList': action.response.data,
      'loadingOrders': false,
    }),
    [ActionTypes.LOAD_PROVIDER_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'ordersList': {},
      'loadingOrders': false,
    }),
    [OrderActionTypes.SELECT_ORDER]: (state, action) => ({
      ...state,
      'selectedOrder': action.payload,
    }),
    [ActionTypes.CHANGE_PROVIDER_TRANSPORT_TYPE]: (state, action) => ({
      ...state,
      'selectedTransportType': action.payload,
    }),
    [ActionTypes.TOGGLE_ORDER_DETAIL]: (state, action) => ({
      ...state,
      'showOrderDetail': action.payload,
    }),
    ...getActionsObject('SUBMIT_EDIT_PROVIDER', {
      ActionTypes,
      'failed': 'Ha ocurrido un error al editar el proveedor seleccionado',
      'success': 'Proveedor actualizado satisfactoriamente',
      'keepValues': true,
    }),
  })(state, action);
};
